import { ColorSwatch, displayOrNone, Row } from 'components/production/components/AisleContent/SummaryComponents';

/**
 * Summary view for the banner carousel editor.
 * Adapts to show only the fields present in the item data.
 *
 * @param {Object} data - Non-configurable banner data.
 * @param {Object} formData - Configurable banner carousel data.
 */
export default function BannerCarouselEditorSummary({ data, formData }) {
    return (
        <div className="flex flex-col gap-4">
            <div className="grid grid-cols-[max-content_1fr] gap-y-1 gap-x-8 items-baseline">
                <Row label="id">
                    <p className="text-sm">{displayOrNone(data.id)}</p>
                </Row>
                <Row label="Name">
                    <p className="text-sm">{displayOrNone(formData.name)}</p>
                </Row>
                <Row label="Banner Items">
                    <p className="text-sm">{formData.items?.length ?? 0} item(s)</p>
                </Row>
            </div>

            {formData.items?.length > 0 && (
                <div className="flex flex-col gap-3">
                    {formData.items.map((item, index) => (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            className="grid grid-cols-[max-content_1fr] gap-y-1 gap-x-8 items-baseline border rounded-md p-3"
                        >
                            <p className="text-xs font-medium text-muted-foreground col-span-2 mb-1">
                                Item {index + 1}
                            </p>
                            <Row label="Image" labelClass="mb-0.5">
                                <BannerItemImage imageUrl={item.imageUrl} />
                            </Row>
                            <Row label="Name">
                                <p className="text-sm">{displayOrNone(item.name)}</p>
                            </Row>
                            {'description' in item && (
                                <Row label="Description">
                                    <p className="text-sm">{displayOrNone(item.description)}</p>
                                </Row>
                            )}
                            {'linkText' in item && (
                                <Row label="Link Text">
                                    <p className="text-sm">{displayOrNone(item.linkText)}</p>
                                </Row>
                            )}
                            <Row label="Link URL">
                                <p className="text-sm">{displayOrNone(item.linkUrl)}</p>
                            </Row>
                            {'bgColor' in item && (
                                <Row label="Background Color" labelClass="transform -translate-y-1">
                                    <ColorSwatch color={item.bgColor} />
                                </Row>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

/**
 * Displays a banner item image or "None" placeholder.
 *
 * @param {string} imageUrl - The image URL.
 */
function BannerItemImage({ imageUrl }) {
    const BASE_URL = 'https://img-cdn.misfitsmarket.com/';

    if (!imageUrl) {
        return <span className="italic text-muted-foreground">None</span>;
    }

    return <img alt="" className="max-w-60 h-15 rounded border" src={`${BASE_URL}${imageUrl}`} />;
}
